import { TaxData, TaxDetails, TaxForm } from '@src/types/Tax'
import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

export const useTaxesStore = defineStore('taxes', () => {
    const taxesData = ref<TaxData[]>([])
    const taxForm = reactive<TaxForm>({
        name: '',
        target: '',
        asset_types: [],
        platform_names: [],
        issuer_country: '',
        investor_country: '',
        formula_amount: '',
        formula_rate: '',
        tax_details: {},
    })

    const taxDetails = ref<TaxDetails[]>([])

    const resetTaxForm = () => {
        taxForm.name = ''
        taxForm.target = ''
        taxForm.asset_types = []
        taxForm.platform_names = []
        taxForm.issuer_country = ''
        taxForm.investor_country = ''
        taxForm.formula_amount = ''
        taxForm.formula_rate = ''
        taxForm.tax_details = {}
        taxDetails.value = []
    }

    return {
        taxesData,
        taxForm,
        taxDetails,
        resetTaxForm,
    }
})
